module.exports = {"pt-BR":{"models":{"user":{"one":"Usuário","other":"Usuários","attributes":{"name":"Nome","email":"E-mail","password":"Senha"}}}}}